import { readTextFromClipboard, writeTextToClipboard } from '../lib/clipboard'
import { createLogic, createLogicMiddleware } from 'redux-logic'

import {
  clipboardPaste,
  clipboardPasteFail,
  clipboardRemoteSend,
  clipboardRemoteReceive,
  clipboardRemoteReceiveSyncDone,
  clipboardRemoteReceiveSyncFail,
  clipboardLocalWrite,
} from '../actions/clipboard'

export const clipboardPasteLogic = createLogic({
  type: clipboardPaste,
  latest: true,

  processOptions: {
    dispatchReturn: true,
    successType: clipboardRemoteSend,
    failType: clipboardPasteFail,
  },

  validate ({ getState, action }, allow, reject) {
    if (getState().clipboard.enabled) {
      allow(action)
    } else {
      reject()
    }
  },

  process ({ action }) {
    return readTextFromClipboard(action.payload)
  }
})

export const clipboardRemoteReceiveLogic = createLogic({
  type: clipboardRemoteReceive,
  latest: true,

  processOptions: {
    dispatchReturn: true,
    successType: clipboardRemoteReceiveSyncDone,
    failType: clipboardRemoteReceiveSyncFail,
  },

  validate ({ getState, action }, allow, reject) {
    if (getState().clipboard.enabled) {
      allow(action)
    } else {
      reject()
    }
  },

  async process ({ action }) {
    await writeTextToClipboard(action.payload.text)
    return action.payload.text
  }
})

export const clipboardLocalWriteLogic = createLogic({
  type: clipboardLocalWrite,
  latest: true,

  processOptions: {
    dispatchReturn: false,
  },

  validate ({ getState, action }, allow, reject) {
    if (getState().clipboard.enabled) {
      allow(action)
    } else {
      reject()
    }
  },

  async process ({ action }, dispatch, done) {
    await writeTextToClipboard(action.payload.text)
    dispatch()
    done()
    return action.payload.text
  }
})

export const clipboardLogicMiddleware = createLogicMiddleware(
  [clipboardPasteLogic, clipboardRemoteReceiveLogic, clipboardLocalWriteLogic],
  {}
)
